import { all, call, put, takeLatest } from 'redux-saga/effects'
import { ApiClient } from '../../../utilities/api';
import { setAddSuggestion, onErrorStopLoad } from '../../slices/resource';
import ApiPath from '../../../constants/apiPath';
import { toast } from 'react-toastify';


function* addSuggestions(action) {
  try {
    const resp = yield call(ApiClient.post, action.url = ApiPath.SuggestionApiPath.ADD_SUGGESTION, action.payload = action.payload);
    if (resp.status) {
      yield put(setAddSuggestion(resp.data.payload));
      yield call(action.payload.cb, action.res = resp)
      toast.success(action.res.data.msg);
    }
    else {
      throw resp
    }
  } catch (e) {
    yield put(setAddSuggestion({}));
    yield put(onErrorStopLoad())
    toast.error(e.response.data.msg);
  }
}


function* userResource() {
  yield all([
    takeLatest('resource/addSuggestion', addSuggestions),
  ])
}

export default userResource;